module.exports = __webpack_public_path__ + "static/img/emg-img.c508a9b3.png";